module.exports = __webpack_public_path__ + "img/generico-filtro.e7cce903.png";